// extracted by mini-css-extract-plugin
export var genbtncounter = "gen-table-module--genbtncounter--JYAqW";
export var gentable = "gen-table-module--gentable--8QGFm";
export var overflow = "gen-table-module--overflow--DvAmB";
export var tableheading = "gen-table-module--tableheading--Ziy7W";